import { AutGITablePropsA } from "../../../utils/models";

import pdfCss from "../../themed/pdf/pdf.module.scss";
import css from "../../pages/reports/pdf.module.scss";

const AutGeneralInfoTableA = (props: AutGITablePropsA) => {
  return (
    <table className={pdfCss["pdf-table"]}>
      <thead>
        <tr>
          <th>PRF(KHz)</th>
          <th>EHT (Volt)</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td className={css["table-title-grid"]}>Gain (dB)</td>
          <td className={css["table-title-grid"]} rowSpan={2}>Averaging Samples</td>
        </tr>

        <tr>
          <td>{props.gain}</td>
        </tr>

        <tr>
          <td className={css["table-title-grid"]}>Scan Mode)</td>
          <td rowSpan={2}>{props.averagingSample}</td>
        </tr>

        <tr>
          <td>{props.scanMode}</td>
        </tr>
      </tbody>
    </table>
  );
};

export default AutGeneralInfoTableA;
